(function() {
  define('app/helpers/timeFormatHelper',['moment', 'handlebars'], function(moment, Handlebars) {
    'use strict';
    return Handlebars.registerHelper('formatTime', function(time, options) {
      if (time == null) {
        return;
      }
      return moment(time).format(options.hash.format);
    });
  });

}).call(this);

//# sourceMappingURL=timeFormatHelper.js.map
;
